import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class StandardActionsCollections extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'StandardActionsCollections'
  // Define default properties here
  static instanceDefaults () {
    return {
      actionCollectionId: null,
      standardActionId: null,
    }
  }
}
const servicePath = 'standard-actions-collections'
const servicePlugin = makeServicePlugin({
  Model: StandardActionsCollections,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
